import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import LegalService from "services/LegalService";
import { useAuth } from "context/authContext";

function PrivacyPolicy() {
  const { logout } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [policy, setPolicy] = useState({
    Title: "",
    Content: "",
    LastModifiedAt: null,
  });

  useEffect(() => {
    const loadPolicy = async () => {
      try {
        const response = await LegalService.getSuppliersPrivacyPolicy();
        const payload = response?.data?.data?.[0] || {};

        setPolicy({
          Title: payload.Title || "Política de Privacidade",
          Content: payload.Content || "",
          LastModifiedAt: payload.LastModifiedAt || null,
        });
      } catch (loadError) {
        setError("Não foi possível carregar a Política de Privacidade no momento.");
      } finally {
        setLoading(false);
      }
    };

    loadPolicy();
  }, []);

  const lastUpdatedLabel = policy.LastModifiedAt
    ? new Date(policy.LastModifiedAt).toLocaleString("pt-BR")
    : "Não informado";

  const handleBackToLogin = async () => {
    await logout();
  };

  return (
    <BasicLayout image={bgImage}>
      <Card sx={{ width: "min(960px, 95vw)", maxHeight: "85vh", overflow: "hidden" }}>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h5" fontWeight="medium" color="white" mt={1}>
            {policy.Title || "Política de Privacidade"}
          </MDTypography>
        </MDBox>

        <MDBox px={3} pt={2} pb={1}>
          <MDTypography variant="caption" color="text">
            Última atualização: {lastUpdatedLabel}
          </MDTypography>
        </MDBox>

        <MDBox px={3} pb={2} sx={{ overflowY: "auto", maxHeight: "58vh" }}>
          {loading && (
            <MDBox display="flex" justifyContent="center" py={6}>
              <CircularProgress size={28} />
            </MDBox>
          )}

          {!loading && error && (
            <MDTypography variant="button" color="error">
              {error}
            </MDTypography>
          )}

          {!loading && !error && (
            <MDTypography
              component="pre"
              variant="button"
              color="text"
              sx={{
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                fontFamily: "monospace",
                lineHeight: 1.6,
                m: 0,
              }}
            >
              {policy.Content}
            </MDTypography>
          )}
        </MDBox>

        <MDBox px={3} pb={3} display="flex" justifyContent="space-between" gap={2}>
          <MDButton color="secondary" variant="outlined" onClick={handleBackToLogin}>
            voltar para login
          </MDButton>

          <MDButton component={Link} to="/consentimento-privacidade" color="info" variant="gradient">
            voltar para consentimento
          </MDButton>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default PrivacyPolicy;
